import {
  CIRCLE_ACTION_VARIANTS,
  type CircleActionVariant
} from "../circle-action-variants";

const RAIL_VARIANT_CYCLE = CIRCLE_ACTION_VARIANTS;

/** Asigna variante por módulo; usa índice para rotar la paleta completa. */
export function resolveSidebarTone(
  id: string,
  path?: string,
  index = 0
): CircleActionVariant {
  const key = `${id} ${path ?? ""}`.toLowerCase();

  if (/explore|inicio|home/.test(key)) return "ocean";
  if (/performance|desempeño/.test(key)) return "rose";
  if (/survey|encuesta|form/.test(key)) return "cyan";
  if (/aprendizaje|learning|evaluacion|evaluaciones|appreciation|recurso|certificado/.test(key)) {
    return "violet";
  }
  if (/challenge|desafio|ranking/.test(key)) return "fuchsia";
  if (/radar|equipo|team|leader/.test(key)) return "indigo";
  if (/download|descarga/.test(key)) return "mint";
  if (/task|tarea/.test(key)) return "emerald";
  if (/action-plan|plan-de-accion|planes-de-accion/.test(key)) return "mint";
  if (/market|coin|producto|canje|carrito|tienda/.test(key)) return "gold";
  if (/career|ruta|profesional|desarrollo/.test(key)) return "emerald";
  if (/benefit|beneficio/.test(key)) return "coral";
  if (/jobyfine|finder|aplicante|oferta|preseleccion|preselección/.test(key)) return "sky";
  if (/config|setting|ajuste|mantainer|usuario|pregunta|division/.test(key)) {
    return "slate";
  }

  return RAIL_VARIANT_CYCLE[index % RAIL_VARIANT_CYCLE.length];
}

export function resolveSidebarChildTone(
  parentTone: CircleActionVariant
): CircleActionVariant {
  return parentTone;
}

export function resolveSidebarToneWithVariety(
  id: string,
  path: string | undefined,
  index: number,
  previousTone?: CircleActionVariant
): CircleActionVariant {
  let variant = resolveSidebarTone(id, path, index);

  if (previousTone && variant === previousTone) {
    const currentIdx = RAIL_VARIANT_CYCLE.indexOf(variant);
    variant =
      RAIL_VARIANT_CYCLE[(currentIdx + 1) % RAIL_VARIANT_CYCLE.length];
  }

  return variant;
}
